module.exports = __webpack_public_path__ + "media/images/front/icons/search-9dc1262cd1fb99eff2b8038dd7451f8e.png";